import React from "react";
import List from "../../../components/list/List";
import connect from "react-redux/es/connect/connect";
import { setSort } from "../../../redux/actions/visitActions";

class ListContainer extends React.Component {
	state = {
		sortOrder: true,
	};
	render() {
		console.log("data in ListContainer:", this.props.data);
		const columns = this.props.columns.map(column => {
			let newColumn = {
				title: column.title,
				dataIndex: column.key,
				key: column.key,
			};
			if (column.sortable) {
				newColumn.onHeaderCell = () => {
					return {
						onClick: () => {
							this.setState({ sortOrder: !this.state.sortOrder }, () => {
								this.state.sortOrder
									? this.props.setSort(column.key, 1)
									: this.props.setSort(column.key, -1);
							});
						},
					};
				};
				newColumn.sorter = () => 0;
			}
			if (column.render) {
				newColumn.render = column.render;
			}
			return newColumn;
		});

		return (
			<List
				columns={columns}
				data={this.props.data}
				page={this.props.page}
				pages={this.props.pages}
				defaultText="Aucune visite trouvée."
			/>
		);
	}
}

const mapStateToProps = state => {
	return {
		data: state.visit.visits || [],
		page: state.visit.page,
		pages: state.visit.pages,
	};
};

const mapDispatchToProps = dispatch => {
	return {
		setSort: (column, sortOrder) =>
			dispatch(setSort({ column: column, sortOrder: sortOrder })),
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ListContainer);



// WEBPACK FOOTER //
// src/containers/activite/visit/ListContainer.js